/**
 * K18 Free Samples (cart drawer)
 * Tiers: 300 AED → 1 | 500 AED → 2 | 700 AED → 3
 * Data: window.k18FreeSampleProducts
 * Mount: #k18-free-samples-mount
 */
(function () {
  if (window.__k18FreeSamplesInit) return;
  window.__k18FreeSamplesInit = true;

  var TIERS = [30000, 50000, 70000];
  var selected = {};
  var enforcing = false;
  var pickerMax = 0;
  var lastStableUnlocked = null;

  function getProducts() {
    return (window.k18FreeSampleProducts || []).filter(function (p) {
      return p && p.id;
    });
  }

  function getCartTotal() {
    try {
      if (window.VueMinicart && window.VueMinicart.$store) {
        return parseInt(window.VueMinicart.$store.getters.cartTotal, 10) || 0;
      }
    } catch (e) {}
    return 0;
  }

  function getCartItems() {
    try {
      if (window.VueMinicart && window.VueMinicart.$store) {
        var items = window.VueMinicart.$store.getters.shoppingCart.items || {};
        return Object.keys(items).map(function (k) {
          return items[k];
        });
      }
    } catch (e) {}
    return [];
  }

  function isFreeSampleItem(item) {
    if (!item) return false;
    if (item.properties && String(item.properties._free_sample) === 'true') return true;
    var products = getProducts();
    var vid = String(item.variant_id || item.id);
    return products.some(function (p) {
      return String(p.id) === vid;
    });
  }

  /** Paid cart total only — free samples (0 AED) never affect tiers */
  function getPaidCartTotal() {
    var items = getCartItems();
    var sum = 0;
    var hasPaidLine = false;
    items.forEach(function (item) {
      if (isFreeSampleItem(item)) return;
      hasPaidLine = true;
      sum += parseInt(item.final_line_price != null ? item.final_line_price : item.line_price, 10) ||
        (parseInt(item.price, 10) || 0) * (parseInt(item.quantity, 10) || 1);
    });
    // Fallback to store total if line prices missing
    if (hasPaidLine && sum === 0) return getCartTotal();
    return sum;
  }

  function getUnlockedCount(total) {
    if (total >= TIERS[2]) return 3;
    if (total >= TIERS[1]) return 2;
    if (total >= TIERS[0]) return 1;
    return 0;
  }

  function getSampleItems() {
    return getCartItems().filter(isFreeSampleItem);
  }

  function getExistingSampleIds() {
    return getSampleItems().map(function (item) {
      return String(item.variant_id || item.id);
    });
  }

  function isCartFetching() {
    try {
      if (window.VueMinicart && window.VueMinicart.$store) {
        return !!window.VueMinicart.$store.getters.isFetching;
      }
    } catch (e) {}
    return false;
  }

  function refreshCart() {
    try {
      if (window.VueMinicart && window.VueMinicart.$store) {
        if (window.VueMinicart.$store._actions && window.VueMinicart.$store._actions.refreshCart) {
          window.VueMinicart.$store.dispatch('refreshCart');
          return;
        }
        window.VueMinicart.$store.dispatch('initCart');
      }
    } catch (e) {
      console.error(e);
    }
  }

  /**
   * Only remove free samples when tier DROPS (e.g. below 500 → keep 1, remove extras).
   * Going 300 → 500+ must NEVER remove already-added samples.
   * Always remove newest extras first so the sample added at 300 stays.
   */
  function enforceSampleLimit() {
    if (enforcing || isCartFetching()) return;

    var items = getCartItems();
    if (!items.length) return;

    var paidTotal = getPaidCartTotal();
    var hasPaid = items.some(function (item) {
      return !isFreeSampleItem(item);
    });

    // Stale/empty total during cart refresh — do not wipe samples
    if (hasPaid && paidTotal <= 0) return;

    var unlocked = getUnlockedCount(paidTotal);
    var samples = getSampleItems();

    // Tier went up or stayed same with room — keep all samples
    if (samples.length <= unlocked) {
      lastStableUnlocked = unlocked;
      return;
    }

    // Only enforce when we truly have more samples than allowed
    // Prefer removing newest samples; keep oldest (first unlocked at 300)
    var sorted = samples.slice().sort(function (a, b) {
      var ai = typeof a.index === 'number' ? a.index : 0;
      var bi = typeof b.index === 'number' ? b.index : 0;
      return ai - bi; // older / lower index first
    });
    var excess = sorted.slice(unlocked); // keep first N, drop newest extras

    if (!excess.length) return;

    enforcing = true;
    var chain = Promise.resolve();

    excess.forEach(function (item) {
      chain = chain.then(function () {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: 0 })
        });
      });
    });

    chain
      .then(function () {
        enforcing = false;
        lastStableUnlocked = unlocked;
        refreshCart();
        setTimeout(renderMount, 300);
      })
      .catch(function (err) {
        console.error('K18 sample enforce error:', err);
        enforcing = false;
      });
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function lockIcon() {
    return (
      '<span class="k18-slot-lock" aria-hidden="true">' +
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none">' +
      '<rect x="5" y="11" width="14" height="10" rx="2" fill="#fff"/>' +
      '<path d="M8 11V8a4 4 0 0 1 8 0v3" stroke="#fff" stroke-width="2" stroke-linecap="round"/>' +
      '<circle cx="12" cy="16" r="1.5" fill="#e91e8c"/>' +
      '</svg></span>'
    );
  }

  function checkIcon() {
    return '<span class="k18-slot-check" aria-hidden="true">✓</span>';
  }

  function formatAedAmount(cents) {
    return 'AED ' + Math.max(0, Math.ceil(cents / 100));
  }

  function nextTierAmount(total, unlocked) {
    if (unlocked >= 3) return 0;
    var nextTier = TIERS[unlocked]; // unlocked 0→300, 1→500, 2→700
    return Math.max(0, nextTier - total);
  }

  function renderMount() {
    var mount = document.getElementById('k18-free-samples-mount');
    if (!mount) return;

    var total = getPaidCartTotal();
    var unlocked = getUnlockedCount(total);
    var progress = Math.min(100, Math.round((total / TIERS[2]) * 100));
    var existing = getExistingSampleIds();

    if (!enforcing && existing.length > unlocked) {
      enforceSampleLimit();
      return;
    }

    /* —— Header message (like k18hair.com) —— */
    var headerHtml = '';
    if (unlocked > 0) {
      // "You unlocked 2 free samples." + add samples
      var title =
        'You unlocked ' +
        unlocked +
        ' free sample' +
        (unlocked > 1 ? 's' : '') +
        '.';
      headerHtml =
        '<div class="k18-slots-header">' +
        '<span class="k18-slots-title">' +
        title +
        '</span>' +
        '<button type="button" class="k18-add-samples-btn" data-k18-open-picker>add samples</button>' +
        '</div>';
    } else {
      // "Spend AED 11 more to unlock free samples."
      var need = nextTierAmount(total, 0);
      headerHtml =
        '<div class="k18-slots-header k18-slots-header--spend">' +
        '<span class="k18-slots-title">Spend ' +
        formatAedAmount(need) +
        ' more to unlock free samples.</span>' +
        '</div>';
    }

    var slots = '';
    for (var i = 1; i <= 3; i++) {
      if (i <= unlocked) {
        var filled = !!existing[i - 1];
        slots +=
          '<button type="button" class="k18-slot k18-slot--unlocked' +
          (filled ? ' k18-slot--filled' : '') +
          '" data-k18-open-picker aria-label="Choose free samples">' +
          '<span class="k18-slot-inner">' +
          (filled ? checkIcon() : '<span class="k18-slot-plus" aria-hidden="true">+</span>') +
          '</span></button>';
      } else {
        slots += '<div class="k18-slot k18-slot--locked" aria-label="Locked">' + lockIcon() + '</div>';
      }
    }

    var slotsHtml =
      '<div class="k18-sample-slots">' +
      headerHtml +
      '<div class="k18-slots-row">' +
      slots +
      '</div></div>';

    /* —— Progress row —— */
    var progressTitle;
    if (unlocked >= 3) {
      progressTitle = 'Next sample tier unlocked.';
    } else if (unlocked === 0) {
      progressTitle = 'Unlock the next sample tier.';
    } else {
      // Partially unlocked — spend more for next tier
      progressTitle =
        'Spend ' + formatAedAmount(nextTierAmount(total, unlocked)) + ' more to unlock free samples.';
    }

    var progressHtml =
      '<div class="k18-samples-progress">' +
      '<div class="k18-progress-header">' +
      '<span class="k18-progress-title">' +
      progressTitle +
      '</span>' +
      '<a href="/collections/shop-all" class="k18-keep-shopping">keep shopping</a>' +
      '</div>' +
      '<div class="k18-progress-bar-track"><div class="k18-progress-bar-fill" style="width:' +
      progress +
      '%"></div></div>' +
      '<div class="k18-progress-labels">' +
      '<span class="k18-progress-label k18-label-300">300 AED</span>' +
      '<span class="k18-progress-label k18-label-500">500 AED</span>' +
      '<span class="k18-progress-label k18-label-700">700 AED</span>' +
      '</div></div>';

    mount.innerHTML = '<div class="k18-samples-wrapper">' + slotsHtml + progressHtml + '</div>';
    ensurePicker();
  }

  function ensurePicker() {
    if (document.querySelector('[data-k18-picker-overlay]')) return;

    var overlay = document.createElement('div');
    overlay.className = 'k18-picker-overlay';
    overlay.setAttribute('data-k18-picker-overlay', '');
    overlay.hidden = true;
    overlay.style.display = 'none';
    overlay.innerHTML =
      '<div class="k18-picker-modal" role="dialog" aria-modal="true">' +
      '<div class="k18-picker-header">' +
      '<button type="button" class="k18-picker-back" data-k18-close-picker>' +
      '<svg width="12" height="20" viewBox="0 0 12 20" fill="none" aria-hidden="true">' +
      '<path d="M10 2L2 10l8 8" stroke="#111" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>' +
      '<span data-k18-picker-title>choose free samples</span>' +
      '</button></div>' +
      '<div class="k18-picker-list" data-k18-picker-list></div>' +
      '<div class="k18-picker-footer">' +
      '<p class="k18-picker-count"><span data-k18-selected-count>0</span>/<span data-k18-max-count>0</span> selected</p>' +
      '<button type="button" class="k18-picker-done" data-k18-done-picker>DONE</button>' +
      '</div></div>';

    document.body.appendChild(overlay);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closePicker();
    });
    overlay.querySelector('[data-k18-close-picker]').addEventListener('click', function (e) {
      e.preventDefault();
      closePicker();
    });
    overlay.querySelector('[data-k18-done-picker]').addEventListener('click', function (e) {
      e.preventDefault();
      onDone();
    });
  }

  /**
   * Opens the choose-samples screen (like k18hair.com)
   * Shows ALL free products; already-in-cart ones are pre-checked.
   */
  function openPicker() {
    ensurePicker();
    var unlocked = getUnlockedCount(getPaidCartTotal());
    if (unlocked < 1) return;

    var existing = getExistingSampleIds();
    pickerMax = unlocked;
    selected = {};

    existing.forEach(function (id) {
      if (Object.keys(selected).length < unlocked) {
        selected[String(id)] = true;
      }
    });

    var overlay = document.querySelector('[data-k18-picker-overlay]');
    var list = overlay.querySelector('[data-k18-picker-list]');
    var title = overlay.querySelector('[data-k18-picker-title]');
    var maxEl = overlay.querySelector('[data-k18-max-count]');
    var countEl = overlay.querySelector('[data-k18-selected-count]');

    title.textContent = 'choose ' + unlocked + ' free sample' + (unlocked === 1 ? '' : 's');
    maxEl.textContent = String(unlocked);
    countEl.textContent = String(Object.keys(selected).length);

    var products = getProducts();

    if (!products.length) {
      list.innerHTML = '<p class="k18-picker-empty">No free samples available right now.</p>';
    } else {
      list.innerHTML = products
        .map(function (p) {
          var id = String(p.id);
          var isSel = !!selected[id];
          return (
            '<div class="k18-picker-item" data-variant-id="' +
            id +
            '">' +
            '<div class="k18-picker-img">' +
            (p.image
              ? '<img src="' + escapeHtml(p.image) + '" alt="' + escapeHtml(p.title) + '" width="80" height="80" loading="lazy">'
              : '') +
            '</div>' +
            '<span class="k18-picker-name">' +
            escapeHtml(p.title) +
            '</span>' +
            '<button type="button" class="k18-picker-add' +
            (isSel ? ' selected' : '') +
            '" data-add-sample="' +
            id +
            '">' +
            (isSel ? '✓' : '+') +
            '</button></div>'
          );
        })
        .join('');

      function updatePickerUI() {
        var count = Object.keys(selected).length;
        var atLimit = count >= pickerMax;
        countEl.textContent = String(count);

        list.querySelectorAll('.k18-picker-item').forEach(function (item) {
          var btn = item.querySelector('[data-add-sample]');
          if (!btn) return;
          var id = btn.getAttribute('data-add-sample');
          if (selected[id]) {
            btn.hidden = false;
            btn.classList.add('selected');
            btn.textContent = '✓';
          } else if (atLimit) {
            btn.hidden = true;
            btn.classList.remove('selected');
            btn.textContent = '+';
          } else {
            btn.hidden = false;
            btn.classList.remove('selected');
            btn.textContent = '+';
          }
        });
      }

      list.querySelectorAll('[data-add-sample]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var id = btn.getAttribute('data-add-sample');
          if (selected[id]) {
            delete selected[id];
          } else {
            if (Object.keys(selected).length >= pickerMax) return;
            selected[id] = true;
          }
          updatePickerUI();
        });
      });

      updatePickerUI();
    }

    overlay.hidden = false;
    overlay.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }

  function closePicker() {
    var overlay = document.querySelector('[data-k18-picker-overlay]');
    if (overlay) {
      overlay.hidden = true;
      overlay.style.display = 'none';
    }
    document.body.style.overflow = '';
  }

  function onDone() {
    var chosenIds = Object.keys(selected);
    var existingItems = getSampleItems();
    var existingIds = existingItems.map(function (item) {
      return String(item.variant_id || item.id);
    });

    var toAdd = chosenIds.filter(function (id) {
      return existingIds.indexOf(id) === -1;
    });
    var toRemove = existingItems.filter(function (item) {
      return chosenIds.indexOf(String(item.variant_id || item.id)) === -1;
    });

    if (!toAdd.length && !toRemove.length) {
      closePicker();
      return;
    }

    var doneBtn = document.querySelector('[data-k18-done-picker]');
    if (doneBtn) doneBtn.disabled = true;

    var chain = Promise.resolve();

    toRemove.forEach(function (item) {
      chain = chain.then(function () {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: 0 })
        });
      });
    });

    if (toAdd.length) {
      chain = chain.then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: toAdd.map(function (id) {
              return {
                id: parseInt(id, 10),
                quantity: 1,
                properties: { _free_sample: 'true' }
              };
            })
          })
        }).then(function (res) {
          if (!res.ok) throw new Error('Add failed');
          return res.json();
        });
      });
    }

    chain
      .then(function () {
        selected = {};
        closePicker();
        refreshCart();
        setTimeout(renderMount, 400);
      })
      .catch(function (err) {
        console.error('K18 Sample sync error:', err);
        alert('Could not update free samples. Please try again.');
      })
      .finally(function () {
        if (doneBtn) doneBtn.disabled = false;
      });
  }

  // Event delegation — survives Vue minicart re-renders
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-k18-open-picker]');
    if (openBtn) {
      e.preventDefault();
      e.stopPropagation();
      openPicker();
    }
  });

  /* =========================================================
     BLOCK free-sample products everywhere except bag picker
     Only allow /cart/add when properties._free_sample === 'true'
     ========================================================= */
  function freeSampleIdSet() {
    var set = {};
    getProducts().forEach(function (p) {
      set[String(p.id)] = true;
    });
    return set;
  }

  function isFreeSampleVariantId(id) {
    if (id == null || id === '') return false;
    return !!freeSampleIdSet()[String(id)];
  }

  function itemAllowsFreeSample(item) {
    if (!item) return false;
    var id = item.id != null ? item.id : item.variant_id;
    if (!isFreeSampleVariantId(id)) return true; // not a free-sample SKU
    var props = item.properties || {};
    return String(props._free_sample) === 'true';
  }

  function payloadAllowsFreeSampleAdd(body) {
    if (!body) return true;
    var data = body;
    if (typeof body === 'string') {
      try {
        data = JSON.parse(body);
      } catch (e) {
        // form-urlencoded: id=123&quantity=1
        var match = /(?:^|&)id=(\d+)/.exec(body);
        if (match && isFreeSampleVariantId(match[1])) return false;
        return true;
      }
    }
    if (data.items && data.items.length) {
      return data.items.every(itemAllowsFreeSample);
    }
    if (data.id != null) return itemAllowsFreeSample(data);
    return true;
  }

  function blockFreeSampleMessage() {
    alert('This free sample can only be added from your shopping bag when you unlock a sample tier.');
  }

  // Block theme ATC buttons for free-sample variants
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest('[data-add-to-cart]');
      if (!btn) return;
      var id = btn.getAttribute('data-add-to-cart');
      if (isFreeSampleVariantId(id)) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        blockFreeSampleMessage();
      }
    },
    true
  );

  // Block native form posts to /cart/add
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || !form.getAttribute) return;
      var action = form.getAttribute('action') || '';
      if (action.indexOf('/cart/add') === -1) return;
      var idInput = form.querySelector('[name="id"]');
      if (idInput && isFreeSampleVariantId(idInput.value)) {
        var prop = form.querySelector('[name="properties[_free_sample]"]');
        if (!prop || prop.value !== 'true') {
          e.preventDefault();
          e.stopPropagation();
          blockFreeSampleMessage();
        }
      }
    },
    true
  );

  // Block fetch('/cart/add.js')
  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : input && input.url;
      if (url && String(url).indexOf('/cart/add') !== -1) {
        var body = init && init.body;
        if (!payloadAllowsFreeSampleAdd(body)) {
          blockFreeSampleMessage();
          return Promise.reject(new Error('K18 free sample blocked'));
        }
      }
      return _fetch.apply(this, arguments);
    };
  }

  // Block axios / XHR /cart/add.js (theme uses axios)
  (function patchXHR() {
    var _open = XMLHttpRequest.prototype.open;
    var _send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__k18_url = url;
      return _open.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function (body) {
      if (this.__k18_url && String(this.__k18_url).indexOf('/cart/add') !== -1) {
        if (!payloadAllowsFreeSampleAdd(body)) {
          blockFreeSampleMessage();
          this.abort();
          return;
        }
      }
      return _send.apply(this, arguments);
    };
  })();

  /** Remove free-sample SKUs that were added without _free_sample (e.g. old PDP adds) */
  function cleanupIllicitFreeSamples() {
    var samples = getCartItems().filter(function (item) {
      if (!isFreeSampleVariantId(item.variant_id || item.id)) return false;
      var props = item.properties || {};
      return String(props._free_sample) !== 'true';
    });
    if (!samples.length) return;

    var chain = Promise.resolve();
    samples.forEach(function (item) {
      chain = chain.then(function () {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: 0 })
        });
      });
    });
    chain.then(function () {
      refreshCart();
    });
  }

  document.addEventListener('cart.init', function () {
    setTimeout(cleanupIllicitFreeSamples, 200);
  });

  function scheduleRender() {
    setTimeout(renderMount, 50);
    setTimeout(renderMount, 400);
  }

  ['cart.init', 'cart.addItem', 'cart.updateItem', 'cart:refresh'].forEach(function (evt) {
    document.addEventListener(evt, scheduleRender);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleRender);
  } else {
    scheduleRender();
  }

  var tries = 0;
  var watch = setInterval(function () {
    tries += 1;
    if (window.VueMinicart && window.VueMinicart.$store) {
      clearInterval(watch);
      window.VueMinicart.$store.subscribe(function () {
        scheduleRender();
      });
      renderMount();
      setTimeout(cleanupIllicitFreeSamples, 500);
    } else if (tries > 40) {
      clearInterval(watch);
    }
  }, 250);
})();
